export default "__VITE_PUBLIC_ASSET__b4c3587c__"